import { useState } from "react";
import { Box, Grid, SelectChangeEvent } from "@mui/material";
import Button from "../../../components/Button";
import { useStyles } from "./styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IndexLabCard from "../../../components/IndexLabCard";

import Select from "../../../components/Select";
import ImgOtherBg from "../../../assets/images/products/Backgroundsection.svg";
import PageHero from "../../../components/PageHero";

const IndexLab = () => {
  const classes = useStyles();

  const [assetClass, setAssetClass] = useState("");
  const [indexFamily, setIndexFamily] = useState("");
  const [ipOwner, setIpOwner] = useState("");

  const handleChangeAssetClass = (event: SelectChangeEvent<any>) => {
    setAssetClass(event.target.value);
  };

  const handleChangeIndexFamily = (event: SelectChangeEvent<any>) => {
    setIndexFamily(event.target.value);
  };

  const handleChangeIpOwner = (event: SelectChangeEvent<any>) => {
    setIpOwner(event.target.value);
  };

  return (
    <Box className={classes.root}>
      <PageHero
        colorScheme="gray"
        mainContentColorScheme="dark"
        title="BITA Index Lab"
        subTitle="Access to the latest innovative indexes in the martket!"
        extraElement={
          <Box>
            <Button label="Get Started!" onClick={() => true} />
          </Box>
        }
      />

      <Box className={classes.main}>
        <Box className={classes.mainTopSection}>
          <Box className={classes.mainHeading}>
            Innovative Indexing done right!
          </Box>
          <Box className={classes.mainText} mt={3}>
            At BITA we are one step ahead with the offering of innovative
            indexes that follow the latest trends in the market, become a
            pioneer at this and start licensing the next generation of
            best-in-class products.
          </Box>
        </Box>

        <Box className={classes.selectsContainer}>
          <Box>
            <Select
              label="Asset Class"
              options={[{ label: "Asset Class 1", value: "asset_class_1" }]}
              value={assetClass}
              variant="filled"
              width={180}
              disableUnderline
              onChange={handleChangeAssetClass}
            />
          </Box>
          <Box>
            <Select
              label="Index Family"
              options={[{ label: "Index Family 1", value: "index_family_1" }]}
              value={indexFamily}
              variant="filled"
              width={180}
              disableUnderline
              onChange={handleChangeIndexFamily}
            />
          </Box>
          <Box>
            <Select
              label="Ip Owner"
              options={[{ label: "Ip Owner 1", value: "ip_owner_1" }]}
              value={ipOwner}
              variant="filled"
              width={180}
              disableUnderline
              onChange={handleChangeIpOwner}
            />
          </Box>
        </Box>

        <Grid className={classes.sectionContainer} container spacing={4}>
          <Grid item xs={12} sm={6}>
            <IndexLabCard
              title="BITA Metaverse Investment Index"
              returnValue={16.85}
              volatility={13.62}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <IndexLabCard
              title="BITA Crypto Index"
              returnValue={16.85}
              volatility={13.62}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <IndexLabCard
              title="BITA Security Infrastructure Index"
              returnValue={16.85}
              volatility={13.62}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <IndexLabCard
              title="BITA Bitcoin Price Index"
              returnValue={16.85}
              volatility={13.62}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <IndexLabCard
              title="BITA Startbucks Stock Index"
              returnValue={16.85}
              volatility={13.62}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <IndexLabCard
              title="BITA Video Technologies Index"
              returnValue={16.85}
              volatility={13.62}
            />
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.sectionFooter}>
              <Box>Displaying 1 - 15 of XXX results</Box>
            </Box>
          </Grid>
        </Grid>

        <Box>
          <Box
            className={classes.bottomSectionInner}
            sx={{
              backgroundImage: `url(${ImgOtherBg})`,
            }}
          >
            <Box className={classes.mainHeading}>
              Do you want to publish your own idea?
            </Box>
            <Box className={classes.bottomSectionText}>
              Create your own indexes and explore its capabilities before
              release them into market.
            </Box>
            <Box className={classes.bottomSectionLink}>
              <ChevronRightIcon />
              Express Interest
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IndexLab;
